import { ButtonRoundedSm } from '@apps-common/components/elements'
import {
  ModalBody,
  ModalCloseButton,
  ModalContainer,
  ModalFooter,
  ModalHeader,
  ModalHeaderContainer
} from '@apps-common/components/modals/modal'
import { ModalDismiss } from '@apps-common/config/modal'
import { CONTROL_TRIGGER_SCHEDULE_ALLOWED_PRODUCTS, productIsSupported } from '@apps-common/config/product-codes'
import { invalidateTriggerQueries } from '@apps-common/lib/invalidateTriggerQueries'
import { useState } from 'react'
import { FORM_TRIGGER_MODIFY, TriggerModifyForm } from './TriggerModifyForm'

export interface ITriggerModifyModalProps {
  status: string
  unitId: string
  productId: string
  triggerId?: number
}

export const TriggerModifyModal = ({
  onDismiss,
  componentProps
}: {
  onDismiss: (data?: string | null | undefined | number, role?: string) => void
  componentProps: ITriggerModifyModalProps
}) => {
  const { unitId, productId, triggerId } = componentProps
  const [loading, setLoading] = useState<boolean>(false)
  const [updating, setUpdating] = useState<boolean>(false)

  const isEditing = !!triggerId && !Number.isNaN(triggerId)
  const supported = productIsSupported(productId, CONTROL_TRIGGER_SCHEDULE_ALLOWED_PRODUCTS)

  return (
    <ModalContainer alwaysMobile>
      <ModalHeaderContainer>
        <div className='flex items-start justify-between'>
          <ModalHeader subtitle={isEditing ? 'Update' : 'Create'} title='Control Trigger' />
          <ModalCloseButton closeModal={() => onDismiss(null, ModalDismiss.Cancel)} />
        </div>
      </ModalHeaderContainer>
      <ModalBody classes='!pt-[90px]'>
        <TriggerModifyForm
          unitId={unitId}
          productId={productId}
          triggerId={triggerId}
          onSave={() => {
            invalidateTriggerQueries(undefined, unitId)
            onDismiss(null, ModalDismiss.Confirm)
          }}
          onLoading={setLoading}
          onUpdating={setUpdating}
        />
      </ModalBody>
      {supported && (
        <ModalFooter>
          <div className='flex items-center justify-between gap-2'>
            <ButtonRoundedSm
              type='submit'
              form={FORM_TRIGGER_MODIFY}
              loading={loading || updating}
              text={isEditing ? 'Update' : 'Create'}
              className='action-success'
            />
            <ButtonRoundedSm
              type='button'
              loading={updating}
              text='Cancel'
              className='action-neutral'
              callback={() => onDismiss(null, ModalDismiss.Cancel)}
            />
          </div>
        </ModalFooter>
      )}
    </ModalContainer>
  )
}
